export const type: string = 'widget_standard_table'
